import { NgModule } from '@angular/core';
import { ConfigurationModule } from '@epicuro-next/platform/configuration';

import { FEATURE_NAME } from './configurations';

@NgModule({
  imports: [ConfigurationModule.forFeature(FEATURE_NAME)],
})
export class StateHomeStateModule {}
